export default __webpack_public_path__ + "static/media/RINNOVODEGLIUFFICI.6cfb671e.pdf";